/* upgradeBanner.js — the in-app upgrade banner: on/off flag and wording.
 *
 * THE SWITCH: UPGRADE_BANNER_ENABLED. OFF by default. To turn it on, set
 * VITE_UPGRADE_BANNER=true on Render and redeploy (VITE_ variables are baked
 * into the bundle at build time, so a restart alone is not enough).
 *
 * THE WORDING below is short PLACEHOLDER copy for Jasper to edit. The numbers
 * are NOT typed in here: they are read from config/plans.js (prices) and
 * config/planAccess.js (league / credit / strategy limits), so editing a price
 * or limit there updates the banner too.
 *
 * Web only. The component also refuses to render on native, and the picking
 * rules live in utils/upgradeBannerLogic.js (tested).
 */

import { PLANS, fmtPrice } from './plans'
import { PLAN_LEAGUE_LIMIT, PLAN_CREDIT_MONTHLY_LIMIT, PLAN_STRATEGY_COUNT } from './planAccess'

export const UPGRADE_BANNER_ENABLED = import.meta.env.VITE_UPGRADE_BANNER === 'true'

const planById = (id) => PLANS.find((p) => p.id === id)

/** Cents-safe difference, so 15.99 - 11.99 prints as $4 rather than $4.000000000000002. */
const diff = (a, b) => Math.round((a - b) * 100) / 100

/** { title, body, cta, to } for a variant ('starter' | 'pro'). */
export function bannerContent(variant) {
  const pro = planById('pro')
  const elite = planById('elite')

  if (variant === 'starter') {
    return {
      title: 'Want more from JAI?',
      body:
        `Starter includes ${PLAN_CREDIT_MONTHLY_LIMIT.starter} JAI credits a month. ` +
        `Pro gives you ${PLAN_CREDIT_MONTHLY_LIMIT.pro} for ${fmtPrice(pro.monthly)}/mo or ${fmtPrice(pro.annualTotal)}/yr, ` +
        `with every launch tool and up to ${PLAN_LEAGUE_LIMIT.pro} leagues.`,
      cta: 'See plans',
      to: '/pricing',
    }
  }

  return {
    title: 'Want more from JAI?',
    body:
      `Elite is ${fmtPrice(diff(elite.monthly, pro.monthly))} more a month for up to ${PLAN_LEAGUE_LIMIT.elite} leagues, ` +
      `${PLAN_CREDIT_MONTHLY_LIMIT.elite} JAI credits a month, ${PLAN_STRATEGY_COUNT.elite} draft strategies, ` +
      `and every new tool as it drops.`,
    cta: 'See Elite',
    to: '/pricing',
  }
}
